import { AuthScope } from "../../features/user/accessRightChecks";

export enum Env {
  DEV = "dev",
  TEST = "test",
  UAT = "uat",
  PROD = "prod",
}

export type FeatureFlagRuleOptions = {
  userIds?: string[];
  authScopes?: AuthScope[];
  excludeEnv?: Env[];
};

export type FeatureFlagRule = FeatureFlagRuleOptions | boolean;
